import { create } from 'zustand';

interface ISidebarState {
  expandedModules: Record<string, boolean>;
  setExpandedModule: (moduleName: string, isExpanded: boolean) => void;
}

/**
 * Store de Zustand para manejar el estado de los módulos expandidos del sidebar.
 * El estado se mantiene solo en memoria durante la sesión de React.
 * Se resetea cuando se recarga la aplicación.
 * 
 * Los valores por defecto se manejan en el componente ExpandableSidebarModule:
 * - operations: true (abierto por defecto)
 * - catalogGroup: false (cerrado por defecto)
 */
const useSidebarState = create<ISidebarState>((set) => ({
  expandedModules: {},
  setExpandedModule: (moduleName: string, isExpanded: boolean) => {
    set(state => ({
      expandedModules: {
        ...state.expandedModules,
        [moduleName]: isExpanded
      }
    }));
  }
}));

export default useSidebarState;
